var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _linearGradient, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1881,
    height: 1750,
    viewBox: "0 0 1881 1750",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#41a5ee",
    stroke: "none",
    d: "M 1801.05603 0 L 517.69397 0 C 473.403992 0 437.5 35.904053 437.5 80.19397 C 437.5 80.19397 437.5 80.19397 437.5 80.19397 L 437.5 437.5 L 1181.25 656.25 L 1881.25 437.5 L 1881.25 80.19397 C 1881.25 35.904053 1845.345947 0 1801.05603 0 L 1801.05603 0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#2b7cd3",
    stroke: "none",
    d: "M 1881.25 437.5 L 437.5 437.5 L 437.5 875 L 1181.25 1006.25 L 1881.25 875 L 1881.25 437.5 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#185abd",
    stroke: "none",
    d: "M 437.5 875 L 437.5 1312.5 L 1137.5 1400 L 1881.25 1312.5 L 1881.25 875 L 437.5 875 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#103f91",
    stroke: "none",
    d: "M 517.69397 1750 L 1801.057007 1750 C 1845.347046 1750 1881.250977 1714.095947 1881.250977 1669.80603 L 1881.250977 1669.80603 L 1881.250977 1312.5 L 437.5 1312.5 L 437.5 1669.80603 C 437.5 1714.095947 473.403992 1750 517.69397 1750 L 517.69397 1750 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#000000",
    stroke: "none",
    opacity: 0.1,
    d: "M 969.80603 350 L 437.5 350 L 437.5 1443.75 L 969.80603 1443.75 C 1014.036011 1443.605957 1049.855957 1407.786011 1050 1363.55603 L 1050 430.19397 C 1049.855957 385.963989 1014.036011 350.144043 969.80603 350 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 926.05603 393.75 L 437.5 393.75 L 437.5 1487.5 L 926.05603 1487.5 C 970.286011 1487.355957 1006.106018 1451.536011 1006.25 1407.30603 L 1006.25 473.94397 C 1006.106018 429.713989 970.286011 393.894043 926.05603 393.75 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 926.05603 393.75 L 437.5 393.75 L 437.5 1400 L 926.05603 1400 C 970.286011 1399.855957 1006.106018 1364.036011 1006.25 1319.80603 L 1006.25 473.94397 C 1006.106018 429.713989 970.286011 393.894043 926.05603 393.75 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#000000",
    stroke: "none",
    opacity: 0.2,
    d: "M 882.30603 393.75 L 437.5 393.75 L 437.5 1400 L 882.30603 1400 C 926.536011 1399.855957 962.356018 1364.036011 962.5 1319.80603 L 962.5 473.94397 C 962.356018 429.713989 926.536011 393.894043 882.30603 393.75 Z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 167.2057,
    y1: 331.0883,
    x2: 795.2943,
    y2: 1418.9117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00001,
    stopColor: "#2368c4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a5dbe",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146ac",
    stopOpacity: 1
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "url(#linearGradient1)",
    stroke: "none",
    d: "M 80.194 393.75 L 882.30603 393.75 C 926.596008 393.75 962.5 429.654053 962.5 473.94397 L 962.5 1276.057007 C 962.5 1320.347046 926.596008 1356.250977 882.30603 1356.250977 L 80.194 1356.250977 C 35.903999 1356.250977 0 1320.347046 0 1276.057007 L 0 473.94397 C 0 429.654053 35.903999 393.75 80.194 393.75 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "#ffffff",
    stroke: "none",
    d: "M 329.088013 1008.788025 C 330.662994 1021.169006 331.713013 1031.932007 332.194 1041.162964 L 334.031006 1041.162964 C 334.730988 1032.412964 336.188995 1021.869019 338.406006 1009.531982 C 340.622986 997.19397 342.621002 986.767029 344.399994 978.250977 L 428.75 614.338013 L 537.81897 614.338013 L 625.31897 972.781982 C 630.403015 995.070007 634.041992 1017.663025 636.213013 1040.418945 L 637.656982 1040.418945 C 639.288025 1018.372009 642.328003 996.453003 646.757019 974.794006 L 716.538025 614.163086 L 815.807007 614.163086 L 693.218994 1135.662964 L 577.237976 1135.662964 L 494.113007 790.299988 C 491.707001 780.369019 488.950989 767.375 485.932007 751.406006 C 482.912994 735.437012 481.032013 723.755981 480.287994 716.406006 L 478.843994 716.406006 C 477.881989 724.893066 476 737.494019 473.200012 754.205994 C 470.399994 770.919006 468.153992 783.284973 466.462006 791.30603 L 388.324005 1135.574951 L 270.373993 1135.574951 L 147.130997 614.336914 L 248.192993 614.336914 L 324.187012 978.992981 C 325.894012 986.474976 327.513 996.450012 329.088013 1008.788025 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.abe93abc143c1c8b029f50807442e35e.svg";
export { ForwardRef as ReactComponent };